/**
 * Sort direction
 */
export enum SortDirection {
  ASC = "asc",
  DESC = "desc"
}
